import React from 'react';
import { connect } from 'react-redux';
import { Card } from '@/components/uikit';
import { Grid } from '@material-ui/core';
import { useTranslate } from '@/locale';
import { Store, GetUserB2BDataInterface, GetUserDataInterface } from '@/types';
import { getUserData } from '@/store/commonDuck/credentialDuck';

interface DoctorProfileBarProps {
  userData?: GetUserB2BDataInterface;
}

const DoctorProfileBar = (props: DoctorProfileBarProps) => {
  const { userData = {} as GetUserB2BDataInterface } = props;
  const { translate } = useTranslate();
  return (
    <Card className="doctor-profile-bar">
      <Grid>
        <Grid className="bordered-bottom py-14 px-14 dis-flex flex-col">
          <span className="text-1">{translate('name')}</span>
          <span className="text-2">{`${userData.name_prefix} ${userData.name} ${userData.name_suffix}`}</span>
        </Grid>
        <Grid className="py-14 px-14 dis-flex flex-col">
          <span className="text-1">{translate('sip')}</span>
          <span className="text-2">{`${userData.default_workplace.sip}`}</span>
        </Grid>
      </Grid>
    </Card>
  );
};

const mapStateToProps = (state: Store) => {
  return {
    userData: getUserData(state.credentials),
  };
};

export default connect(mapStateToProps, null)(DoctorProfileBar);
